import HeroSkeleton from './HeroSkeleton';

export default HeroSkeleton;
